import React from 'react';
import { StyledLabel } from 'src/ui/common/atoms/label/label.styles';

type Props = React.ComponentPropsWithoutRef<'div'>

export const Label: React.FC<Props> = ({ children, ...props }: Props) => (
    <StyledLabel
        {...props}
    >
        <>
            {children}
        </>
    </StyledLabel>
);

Label.displayName = 'Label';
